/* global $ */ /* Bliss */
import ModalOverlay from './ModalOverlay'

export default class LoginRegisterHandler {
  constructor(openerElements) {
    const contents = $.create({
      tag: 'div',
      className: 'login-register__body',
      contents: [
        {
          tag: 'div',
          className: 'login-register__titel',
          contents: ['Login & Tsüri-Member werden'],
        },
        {
          tag: 'hr',
        },
        {
          tag: 'div',
          className: 'login-register__button-wrapper',
          contents: [
            {
              tag: 'div',
              className: 'login-register__button login__button',
              contents: ['Login'],
            },
            {
              tag: 'a',
              href: '../../../accounts/signup',
              className: 'login-register__button register__button',
              contents: ['Tsüri-Member werden'],
            },
          ],
        },
      ],
    })

    this.modal = new ModalOverlay(contents)
    openerElements._.addEventListener('click', e => {
      e.preventDefault()
      this.modal.show()
    })
    this.login(this.modal, contents)
  }

  login = (modal, contents) => {
    document
      .querySelector('.login__button')
      .addEventListener('click', function() {
        contents.parentNode.removeChild(contents)
        document.querySelector('.modal-overlay__body').appendChild(loginPart)
      })
    document
      .querySelector('.modal-overlay__close')
      .addEventListener('click', function() {
        loginPart.parentNode.removeChild(loginPart)
        document.querySelector('.modal-overlay__body').appendChild(contents)
      })
  }
}
const nextPart = 'next=' + encodeURIComponent(window.location.pathname)
const loginPart = $.create({
  tag: 'div',
  className: 'login__body',
  contents: [
    {
      tag: 'div',
      className: 'login__titel',
      contents: ['Login'],
    },
    {
      tag: 'hr',
    },
    {
      tag: 'div',
      className: 'login__button-wrapper',
      contents: [
        {
          tag: 'a',
          href: '/accounts/login/?' + nextPart,
          className: 'login__button mail__button',
          contents: ['mail & passwort'],
        },
        {
          tag: 'a',
          href: '/accounts/oauth2/facebook/?' + nextPart,
          className: 'login__button facebook__button',
          contents: ['facebook'],
        },
        {
          tag: 'a',
          href: '/accounts/oauth2/twitter/?' + nextPart,
          className: 'login__button twitter__button',
          contents: ['twitter'],
        },
        {
          tag: 'a',
          href: '/accounts/oauth2/google/?' + nextPart,
          className: 'login__button google__button',
          contents: ['google'],
        },
        {
          tag: 'a',
          href: '/accounts/email/?context=login&' + nextPart,
          className: 'login__button mail__button',
          contents: ['login link per mail'],
        },
      ],
    },
  ],
})
